import { z } from 'zod';

export const UploadDtoScheme = z.object({
	id: z.number().optional().nullable().describe('Уникальный идентификатор'),
	path: z.string().describe('Путь к файлу'),
	name: z.string().optional().nullable().describe('Название файла'),
	type: z.string().optional().nullable().describe('Тип файла'),
});

export type UploadDto = z.infer<typeof UploadDtoScheme>;
